// extracted by mini-css-extract-plugin
module.exports = {"input":"PostSimpleWidget_input__13XO0","icon":"PostSimpleWidget_icon__SfFWZ"};